import templateUrl from "servicestack/table-audit/table-audit.htm";
import controller from "servicestack/table-audit/table-audit.controller";

export default {
  bindings: {
    retailerId: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};